import {useActions, useGetters, useMutators, useState} from './_default.js';
import axios from "axios";
export default {
    namespaced: true,
    state: {
        ...useState(),
        listUrl: '/payload/paginated/sidebar/object-group',
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
        changeStatus({ state }, group) {
            const index = state.listMap[group.id];
            state.list[index].open = !state.list[index].open;
            axios.put('/object-group/change-status', { id: group.id }).then(() => {
                // do something...
            });
        },
    },
}
